import actionTypes from "./actions/actiontypes";

const {
  REQUEST_EMAIL_ADDRESS_BOOK,
  RECEIVE_EMAIL_ADDRESS_BOOK,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS,
  RECEIVE_GROUPS,
  REQUEST_GROUPS,
  GROUP_CLEAR_ERRORS,
  GROUP_SERVER_ERROR_OCURED,
  SEARCH_KEYWORD,
  SORT_ADDRESS_BOOK
} = actionTypes;

const emailAddressBookReducer = (
  state = {
    isFetchingList: false,
    emailAddressBook: [],
    groups: [],
    hasServerError: false,
    errors: {},
    msg: "",
    isFetchingGroups: false,
    hasGroupServerError: false,
    groupErrors: {},
    hasFetchedEmailAddressBook: false,
    hasFetchedGroups: false
  },
  action
) => {
  switch (action.type) {
    case REQUEST_EMAIL_ADDRESS_BOOK:
      return Object.assign({}, state, {
        isFetchingList: true,
        hasServerError: false,
        errors: {},
        success: false,
        msg: "",
      });
    case RECEIVE_EMAIL_ADDRESS_BOOK:
      return Object.assign({}, state, {
        isFetchingList: false,
        emailAddressBook: action.emailAddressBook.map(a => {
          a.isVisible = true;
          return a;
        }),
        hasFetchedEmailAddressBook: true
      });
    case CLEAR_ERRORS:
      return Object.assign({}, state, {
        hasServerError: false,
        errors: {},
        success: false,
        msg: "",
      });
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasServerError: true,
        errors: action.errors,
        success: false,
      });
    case REQUEST_GROUPS:
      return Object.assign({}, state, {
        isFetchingGroups: true,
        hasGroupServerError: false,
        groupErrors: {},
      });
    case RECEIVE_GROUPS:
      return Object.assign({}, state, {
        isFetchingGroups: false,
        groups: action.groups,
        hasFetchedGroups: true
      });
    case GROUP_CLEAR_ERRORS:
      return Object.assign({}, state, {
        hasGroupServerError: false,
        groupErrors: {},
      });
    case GROUP_SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasGroupServerError: true,
        groupErrors: action.errors
      })
    case SEARCH_KEYWORD:
      let emailAddressBook = state.emailAddressBook;
      emailAddressBook = emailAddressBook.map(a => {
        if (action.keyword === '') {
          a.isVisible = true;
          return a;
        } else if (action.keyword) {
          a.isVisible = (a.email_address.toLowerCase().includes(action.keyword.toLowerCase()) || a.name.toLowerCase().includes(action.keyword.toLowerCase()));
        }
        return a
      })
      return Object.assign({}, state, {
        emailAddressBook
      })
    case SORT_ADDRESS_BOOK:
      console.log("Sorting type: ", action.sortType, action.by);
      var addressBook = state.emailAddressBook;
      if (action.sortType === 'name' || action.sortType === 'email_address') {
       if (action.by === "alphabetical") {
         addressBook = sortAlphabetically(addressBook, action.sortType)
        } else if(action.by === "japanese-syllabary") {
          addressBook = sortByJapaneseSyllabary(addressBook, action.sortType);
        } else if (action.by === "numerical") {
          addressBook = sortNumerically(addressBook, action.sortType)
        }
      } else if (action.sortType === 'role') {
        addressBook = addressBook.sort((a, b) => a.role.includes(action.by) ? -1 : 1);
      }

      return Object.assign({}, state, { emailAddressBook: [...addressBook] });
    default:
      return state;
  }
};

export function sortAlphabetically(addressBook, field) {
  return addressBook.sort(
    (a, b) =>
      isFinite(a[field][0]) - isFinite(b[field][0])  ||
      a[field].localeCompare(b[field])
  );
}

export function sortByJapaneseSyllabary(addressBook, field) {
  return addressBook.sort(
    (a, b) =>
      isFinite(a[field][0]) - isFinite(b[field][0]) || (/[a-zA-Z]/).test(a[field]) - (/[a-zA-Z]/).test(b[field]) ||
      a[field].localeCompare(b[field], "ja")
  );
}

export function sortNumerically(addressBook, field) {
  return addressBook.sort(function (a, b) {
    if (
      a[field].match(/^\d.*/) &&
      b[field].match(/^\d.*/)
    ) {
      return parseInt(a[field]) - parseInt(b[field]);
    }
    return a[field]
      .toLowerCase()
      .localeCompare(b[field].toLowerCase());
  });
}

export default emailAddressBookReducer;



// WEBPACK FOOTER //
// src/routes/EmailAddressBook/reducer.js